import React from 'react';
import { useSelector } from 'react-redux';
import * as ACL from 'domain/restriction';

import { isPayModuleCompanyPermissionsLoadedSelector } from 'domain/env';
import { isProvidersLoadedSelector } from 'domain/paySettings';

import Route404 from 'pages/servicePage/page404';

const mapStateToProps = (state) => ({
  restrictions: ACL.myRestriction(state),
  isPayModuleCompanyPermissionsLoaded: isPayModuleCompanyPermissionsLoadedSelector(state),
  isProvidersLoaded: isProvidersLoadedSelector(state),
});

// eslint-disable-next-line react/prop-types
function RestrictedRouteForPay({ children, restriction }) {
  const { restrictions, isPayModuleCompanyPermissionsLoaded, isProvidersLoaded } = useSelector(mapStateToProps);
  const ACLFilterFN = ACL.arrayFilter(restrictions);
  const isAvailable = ACLFilterFN({ restriction });

  // TODO: NEED RECHECK
  if (!isAvailable && isPayModuleCompanyPermissionsLoaded && isProvidersLoaded) return <Route404 />;

  return children;
}

export default RestrictedRouteForPay;
